import React, { ChangeEvent, useEffect, useState } from 'react'
import { FormField } from '@/components/Form/FormField'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { NameDto } from 'api/Common/Types'

type Version = NameDto<string | undefined>

interface OuterProps {
  isOpen?: boolean
  onClose(): void
  data?: Version
  handleChange(values: Version): Promise<void>
}

export const VersionModal: React.FC<OuterProps> = ({ handleChange, data, isOpen, onClose }) => {
  const [version, setVersion] = useState<Version>(data ?? { id: undefined, name: '' })
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    setVersion(data ?? { id: undefined, name: '' })
  }, [data, isOpen])

  const handleSubmit = async () => {
    if (!version.name?.trim() || isSubmitting) {
      return
    }

    setIsSubmitting(true)

    try {
      await handleChange({ ...version, name: version.name.trim() })
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{version.id ? 'Edit Version' : 'Add Version'}</DialogTitle>
        </DialogHeader>
        <FormField
          name='name'
          label='Name'
          value={version.name ?? ''}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setVersion({ ...version, name: e.target.value })
          }
        />
        <DialogFooter>
          <Button disabled={isSubmitting} onClick={onClose} type='button' variant='outline'>
            Cancel
          </Button>
          <Button
            disabled={isSubmitting || !version.name?.trim()}
            type='button'
            onClick={handleSubmit}
          >
            {version.id ? 'Save' : 'Add'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
